<template>
  <div
    class="company_item"
    @click="turnToDetail()"
  >
    <yq-img
      class="logo"
      :img="companyInfo.logo"
      :textDefault="companyInfo.org_name"
    ></yq-img>
    <div class="company_info">
      <div class="company_name" v-html="companyInfo.highlight"></div>
      <div class="tags">
        <span class="tag tag_listed" v-if="companyInfo.listed_state.length">{{companyInfo.listed_state[0]}}</span>
        <span class="tag tag_state" v-if="companyInfo.state">{{companyInfo.state}}</span>
        <span class="tag tag_industry" v-if="companyInfo.third_industry">{{companyInfo.third_industry}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    companyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    turnToDetail() {
      this.$emit('turnToDetail')
    }
  }
}
</script>

<style lang="less" scoped>
.company_item {
  background: #FFF;
  border-radius: 4px;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 10px;
  .logo {
    width: 40px;
    height: 40px;
  }
  .company_info {
    .company_name {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.82);
      line-height: 22px;
      font-weight: 700;
    }
    .tags {
      margin-top: 4px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      color: rgba(0, 0, 0, 0.52);
      .tag {
        font-size: 11px;
        padding: 2px 4px;
        margin-right: 8px;
        border-radius: 2px;
      }
      .tag_listed {
        background: #EBF0FF;
        color: #2652ff;
      }
      .tag_state {
        background: #FFF3F0;
        color: #F22424;
      }
      .tag_industry {
        background: rgba(0, 0, 0, 0.02);
        color: rgba(0, 0, 0, 0.52);
      }
    }
  }
}
/deep/ em {
  color: #F0330D;
  font-style: normal;
}
</style>
